import { AGraphEdge } from '../../../core/Edge';

export class AccessMapEdge extends AGraphEdge {}
